<template>
  <div class="dashboard-vue row">
        <div class="col-md-12">
            <!-- <table class="table">
                <thead>
                    <tr>
                        <th>帳號</th>
                        <th>Email</th>
                        <th :class="`-clickable ${sortBy === 'department' ? '-sorting' : ''}`" @click="sortBy = sortBy !== 'department' ? 'department' : ''">部門</th>
                        <th :class="`-clickable ${sortBy === 'status' ? '-sorting' : ''}`" @click="sortBy = sortBy !== 'status' ? 'status' : ''">狀態</th>
                        <th>查看</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="tr" v-for="(user, index) in sortedUsers" :key="index" v-show="user.left_at === null">
                        <td><a :href="user.attendance_url">{{ user.name }}</a></td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.department_display }}</td>
                        <td>{{ user.dayoff_status }}</td>
                        <td>
                            <a class="btn btn-default" :href="user.attendance_url">查看</a>
                        </td>
                    </tr>
                </tbody>
            </table> -->
            <div class="btn-container">
                <span class="label">排序</span>
                <button :class="`btn btn-sort -clickable ${sortBy === 'department' ? '-sorting' : ''}`" @click="sortBy = sortBy !== 'department' ? 'department' : ''">部門</button>
                <button :class="`btn btn-sort -clickable ${sortBy === 'status' ? '-sorting' : ''}`" @click="sortBy = sortBy !== 'status' ? 'status' : ''">狀態</button>
            </div>
            <ul>
                <li class="user-item row" v-for="(user, index) in sortedUsers" :key="index" v-show="user.left_at === null">
                    <span class="col-sm-8 col-xs-12 avatar-container">
                        <img :class="`avatar -${user.dayoff_status}`" :src="user.slack_avatar" v-if="user.slack_avatar">
                        <span :class="`avatar-no -${user.dayoff_status}`" v-if="!user.slack_avatar"></span>
                        <span class="name-block">
                            <h2 class="name">
                                {{ user.name }}
                                <span :class="`status-indicator -${user.dayoff_status}`"></span>
                            </h2>
                            <span class="email">{{ user.email }}</span>
                        </span>
                    </span>
                    <span class="col-sm-2 col-xs-8 department">{{ user.department_display }}</span>
                    <span class="col-sm-2 col-xs-4 more-container">
                        <a class="btn btn-action" :href="user.attendance_url">
                            <span></span><span></span><span></span>
                        </a>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        users: Array
    },
    data() {
        return {
            sortBy: '',
            sortedUsers: []
        }
    },
    mounted() {
        this.sortedUsers = [...this.users];
    },
    watch: {
        sortBy(value) {
            switch (value) {
                case 'department':
                    this.sortedUsers = [...this.users].sort((a, b) => b.department_display.localeCompare(a.department_display));
                    break;

                case 'status':
                    this.sortedUsers = [...this.users].sort((a, b) => b.dayoff_status.localeCompare(a.dayoff_status));
                    break;

                default:
                    this.sortedUsers = [...this.users];
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scope>
.dashboard-vue {
    .-clickable {
        cursor: pointer;
        &::after {
            content: "\e150";
            position: relative;
            display: inline-block;
            top: 2px;
            left: 4px;
            font-family: 'Glyphicons Halflings';
            opacity: 0.1;
            margin-left: 4px;
        }
    }
    .-sorting {
        font-weight: 900;

        &::after {
            opacity: 0.7;
        }
    }
    .tr {
        >td {
            vertical-align: middle !important;
        }
        &:hover {
            background: linear-gradient(145deg, #e6e6e6, #ffffff);
        }
    }

    .btn-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 32px;

        >.label {
            font-size: 16px;
            color: #725A7A;
            margin-right: 16px;
        }

        >.btn {
            outline: none;
            &:active {
                outline: none;
            }
            color: #725A7A;
            border: 1px solid currentColor;
            margin-left: 16px;
        }
    }

    .user-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        padding: 4px 0px;
        border-radius: 50em;
        transition: all .1s;
        flex-wrap: wrap;

        &:hover {
            background-color: #fafafa;
            box-shadow: 2px 4px 6px rgba(0,0,0,0.1);

            .btn-action {
                opacity: 1;
            }
        }

        .avatar-container {
            display: inline-flex;
            align-items: center;
        }

        .avatar, .avatar-no {
            display: inline-block;
            width: 48px;
            height: 48px;
            border-radius: 50em;
            margin-right: 16px;
            background-color: #ddd;
        }

        .status-indicator {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50em;
            background-color: #ddd;
            margin-left: 16px;
            &.-working { 
                background-color: rgb(11, 211, 94);
                box-shadow: 0 0 8px rgba(11, 211, 94, 0.7);
            }
        }

        .name-block {
            display: flex;
            flex-direction: column;
            overflow-x: hidden;

            .name {
                font-size: 18px;
                margin: 0;
                display: flex;
                align-items: center;
            }

            .email {
                color: #888;
            }
        }

        .department {
            color: #999;

            @media (max-width: 767px) {
                padding-left: 79px;
            }
        }

        .more-container {
            display: inline-flex;
            justify-content: flex-end;
        }


        .btn-action {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #725A7A;
            width: 32px;
            height: 32px;
            padding: 0;
            opacity: 0.2;
            transition: all .2s;

            >span {
                display: inline-block;
                width: 3px;
                height: 3px;
                background-color: #725A7A;
                border-radius: 50em;
                margin: 0 1.5px;
            }
        }
    }
}
</style>